<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import AccountType from '@/dc-it/models/AccountType'

export default {
  name: 'UsersView',
  components: { TableComponent },
  data() {
    return {
      model: AccountType,
    }
  },
}
</script>

<style scoped>

</style>
